import './MobileRadioList.scss';

import { arrayOf, func, object, oneOfType, string } from 'prop-types';
import React from 'react';

import MobileRadio from 'components/shared/Radio/MobileRadio';

const MobileRadioList = ({
  className,
  label,
  onChange,
  options,
  selection
}) => (
  <div className="select-group e2e-group-by-select">
    <p className="mobile-radio-select-label">{label}</p>

    {options.map((option, i) => (
      <MobileRadio
        className={className}
        key={i}
        name="time-period"
        onChange={onChange}
        option={option}
        selected={selection}
      />
    ))}
  </div>
);

MobileRadioList.propTypes = {
  className: string,
  label: string,
  onChange: func,
  options: arrayOf(oneOfType([string, object])),
  selection: string
};

export default MobileRadioList;
